<template>
  <div class="inline-block opacity-10" :class="dividerClass"></div>
</template>
<script setup lang="ts">
  import { computed } from 'vue';

  interface DividerProps {
    alignment?: 'vertical' | 'horizontal';
  }

  const props = defineProps<DividerProps>();
  const dividerClass = computed(() => {
    return {
      'w-full border-t': props.alignment === 'horizontal',
      'h-full border-l': props.alignment === 'vertical',
      'bg-cadet-gray': true
    };
  });
</script>
